module.exports = __webpack_public_path__ + "img/ganesh.435db0d1.png";